import { boardEl, indicatorsBgEl, loseLifeDialogEl, mapEl } from "./elements";
import { GAME_MODE, gameState } from "./game/gameState";
import { handleAds } from "./iap";
import { CLASSIC_LEVELS } from "./levels/definitions";
import { handleLivesModal } from "./lives";
import { play, showLoseLifeDialog, showMap } from "./map";
import { closeMenu } from "./menu";
import { stack } from "./nav";
import store from "./store";
import { setColors } from "./style";
import { updateStyles } from "./nav/styles";
import { autoTranslate } from "./translate";

export const playClassic = () => {
  gameState.mode = GAME_MODE.CLASSIC;
  play({
    level: CLASSIC_LEVELS[store.classicLevelIdx],
    delay: 0,
  });
  updateStyles();
  autoTranslate();
  handleAds();
};

const _playQuest = () => {
  gameState.mode = GAME_MODE.STORY;
  showMap();
  updateStyles();
  autoTranslate();
};

export const playQuest = (timeout = true) => {
  gameState.mode = GAME_MODE.STORY;
  handleLivesModal();
  if (store.numLives > 0 || !timeout) _playQuest();
  else setTimeout(_playQuest, 500);
};

export const showMainMenu = (e, force = false) => {
  e && e.stopImmediatePropagation();
  if (force || store.screenNamePrev != "game") {
    mapEl.innerHTML = "";
    boardEl.innerHTML = "";
    indicatorsBgEl.innerHTML = "";
    stack.reset();
    stack.push("main_menu");
    setColors();
    closeMenu();
    updateStyles();
    autoTranslate();
  } else if (store.maxLevelIdx == store.levelIdx) {
    loseLifeDialogEl.dataset.destination = "main_menu";
    showLoseLifeDialog();
  } else showMainMenu(e, true);
};
